// Hand a destination to the device's routing app: Android's geo: intent lets
// the user pick any installed app (Google Maps, Waze, OsmAnd, ...), Apple
// devices open Apple Maps, everything else gets Google Maps in the browser.
export const ROUTE_PLATFORM = Object.freeze({
  ANDROID: "android",
  APPLE: "apple",
  OTHER: "other",
});

const ANDROID_USER_AGENT = /Android/i;
const APPLE_MOBILE_USER_AGENT = /iPhone|iPad|iPod/i;
const MAC_USER_AGENT = /Macintosh/i;

export const detectRoutePlatform = ({ userAgent = "", maxTouchPoints = 0 } = window.navigator) => {
  if (ANDROID_USER_AGENT.test(userAgent)) return ROUTE_PLATFORM.ANDROID;
  // iPadOS reports a desktop Mac user agent; only the touch screen gives it away.
  const isTouchMac = MAC_USER_AGENT.test(userAgent) && maxTouchPoints > 1;
  if (APPLE_MOBILE_USER_AGENT.test(userAgent) || isTouchMac) return ROUTE_PLATFORM.APPLE;
  return ROUTE_PLATFORM.OTHER;
};

const ROUTE_URL_BUILDERS = Object.freeze({
  [ROUTE_PLATFORM.ANDROID]: (destination) => `geo:0,0?q=${destination}`,
  [ROUTE_PLATFORM.APPLE]: (destination) => `https://maps.apple.com/?daddr=${destination}`,
  [ROUTE_PLATFORM.OTHER]: (destination) => `https://www.google.com/maps/dir/?api=1&destination=${destination}`,
});

export const buildRouteUrl = (address, platform) => ROUTE_URL_BUILDERS[platform](encodeURIComponent(address));

// A geo: link hands over to an app; a new tab would stay behind empty.
export const opensInBrowser = (platform) => platform !== ROUTE_PLATFORM.ANDROID;
